import React from 'react'
import { Link as RebassLink } from 'rebass'
import { Link as RouterLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import styled from 'styled-components'
// import { lighten, darken } from 'polished'

const WrappedLink = ({ external, children, ...rest }) => (
    <RebassLink
        target={external ? '_blank' : null}
        rel={external ? 'noopener noreferrer' : null}
        color="#2f80ed"
        {...rest}
    >
      {children}
    </RebassLink>
)

WrappedLink.propTypes = {
  external: PropTypes.bool,
}

const Link = styled(WrappedLink)`
  color: ${({ theme }) => (theme.link)};
  text-decoration: none;
`

export default Link

export const CustomLink = styled(RouterLink)`
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  color: #76b0de;

  &:visited {
    opacity: 0.8;
    color: #76b0de;
  }

  &:hover {
    cursor: pointer;
    text-decoration: none;
    underline: none;
    color: #76b0de;
  }
`

export const BasicLink = styled(RouterLink)`
  text-decoration: none;
  color: inherit;
  &:hover {
    cursor: pointer;
    text-decoration: none;
    underline: none;
  }
`
